import { defineComponent as o } from "vue";
import t from "./index12.js";
const m = o({
  name: "LogoSSL",
  components: {
    DynamicLogo: t
  },
  props: {
    htmlContent: {
      type: String,
      required: !0
    }
  }
});
export {
  m as default
};
//# sourceMappingURL=index10.js.map
